import { forwardRef } from "react";
import { twMerge } from "tailwind-merge";

export type ILabelProps = React.LabelHTMLAttributes<HTMLLabelElement>;

export const Label = forwardRef<HTMLLabelElement, ILabelProps>((props, ref) => {
  const { className, ...rest } = props;

  return (
    <label
      className={twMerge(
        "text-grey-dark cursor-pointer text-sm font-medium leading-5",
        className,
      )}
      ref={ref}
      {...rest}
    />
  );
});
